import Vue from 'vue'
import Vuex from 'vuex'

/* import modules */
import Admin from './modules/Admin'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Admin,
  }
})
